.root {
  will-change: opacity;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.root--loaded {
  opacity: 1;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1rem;
  margin-left: -1rem;
}
